import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Motor search params (http to value object)
 */
export default class AdsSearchParamsHttpToValueObjectMapper extends Mapper {
  /**
   * @param {Object} deps
   * @param {Array} deps.bodyTypeIds
   * @param {Number} deps.fuelTypeId
   * @param {Object} deps.odometerReading
   * @param {Number} deps.modelId
   * @param {Number} deps.makeId
   * @param {Number} deps.provinceId
   * @param {String} deps.keywords
   * @param {Number} deps.count
   */
  constructor({bodyTypeIds, fuelTypeId, odometerReading, modelId, makeId, provinceId, keywords, count} = {}) {
    super()
    this._bodyTypeIds = bodyTypeIds
    this._fuelTypeId = fuelTypeId
    this._odometerReading = odometerReading
    this._modelId = modelId
    this._makeId = makeId
    this._provinceId = provinceId
    this._keywords = keywords
    this._count = count
  }

  /**
   * @return {Object}
   */
  map = () => ({
    bodyTypes: this._bodyTypeIds,
    fuelType: this._fuelTypeId,
    kmsMax: this._odometerReading.max,
    kmsMin: this._odometerReading.min,
    model: this._modelId,
    brand: this._makeId,
    province: this._provinceId,
    keywords: this._keywords,
    count: this._count
  })
}
